(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("reselect"));
	else if(typeof define === 'function' && define.amd)
		define(["reselect"], factory);
	else if(typeof exports === 'object')
		exports["ReduxRequests"] = factory(require("reselect"));
	else
		root["ReduxRequests"] = factory(root["Reselect"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_reselect__) {
return 